import axios from 'axios';

export default {
    namespaced: true,
    state: {
      optOutRate1: 0,
      optOutRate2: 0,
      filteredRate1: 0,
      filteredRate2: 0,
      optOutOkRate: 0,
      filteredOkRate: 0,
      isBlocked: false,
      isLoading: false,
      getRatesError: null,
      isPermaBlocked: false,
      rates: [],
    },
    mutations: {
      setRates(state, rates) {
        if (rates && rates.length > 0) {
          state.optOutRate1 = rates[0].opt_out_rate_1;
          state.filteredRate1 = rates[0].filtered_rate_1;
          state.optOutRate2 = rates[0].opt_out_rate_2;
          state.filteredRate2 = rates[0].filtered_rate_2;
          state.optOutOkRate = rates[0].opt_out_ok_rate;
          state.filteredOkRate = rates[0].filtered_ok_rate;
          state.isBlocked = rates[0].is_blocked;
          state.rates = rates;
          state.getRatesError = null;
        }
      },
      setIsPermaBlocked(state, blocked) {
        state.isPermaBlocked = blocked;
      },
      resetRates(state) {
        state.optOutRate1 = 0;
        state.filteredRate1 = 0;
        state.optOutRate2 = 0;
        state.filteredRate2 = 0;
        state.optOutOkRate = 0;
        state.filteredOkRate = 0;
        state.getRatesError = null;
        state.rates = [];
      },
      setGetRatesError(state, error) {
        state.getRatesError = error;
      },
      setIsLoading(state, isLoading) {
        state.isLoading = isLoading;
      },
    },
  
    actions: {
      async getRates({ commit }) {
        commit('setIsLoading', true);
        try {
          const response = await axios.get(
            `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/user-error-rates`,
          );
          commit('setRates', response.data);
        } catch(error) {
          commit('setGetRatesError', error.data.error)
        } finally {
          commit('setIsLoading', false);
        }
      },
      async getIsUserBlocked({ commit }) {
        commit('setIsLoading', true);
        try {
          const response = await axios.get(
            `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/is-user-blocked`,
          );
          if (response.data) {
            commit('setIsPermaBlocked', response.data.blocked);
          }
        } catch(error) {
          commit('setGetRatesError', error.data.error)
        } finally {
          commit('setIsLoading', false);
        }
      },
    },
  };
  